var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"picker-goods"},[_c('SpFilterForm',{attrs:{"model":_vm.formData,"lang":_vm.value.lang,"size":"small"},on:{"onSearch":_vm.onSearch,"onReset":_vm.onSearch}},[_c('SpFilterFormItem',{attrs:{"prop":"keywords"}},[_c('el-input',{attrs:{"clearable":"","placeholder":_vm.lang=='zh'?'请输入商品名称':'Please enter product name'},model:{value:(_vm.formData.keywords),callback:function ($$v) {_vm.$set(_vm.formData, "keywords", $$v)},expression:"formData.keywords"}})],1)],1),_c('SpFinder',{ref:"finder",attrs:{"reserve-selection":"","row-key":"item_id","other-config":{
      'max-height': 416,
      'header-cell-class-name': _vm.cellClass
    },"url":"/goods/items","show-pager-text":_vm.showPagerText,"fixed-row-action":true,"setting":{
      columns: [
        {
          name: _vm.lang=='zh'?'缩略图':'thumbnail',
          key: 'pic',
          render: (h, { row }) =>
            h('div', { class: 'item-info' }, [
              h('div', { class: 'item-image' }, [
                h('SpImage', {
                  props: {
                    src: JSON.parse(row.still_life_image)[0]?.url||row.still_life_image[0]?.url,
                    width: 60,
                    height: 60
                  }
                })
              ])
            ])
        },
        { name: _vm.lang=='zh' ? '商品ID' : 'Product ID', key: 'item_id', width: 80 },
        { name: _vm.lang=='zh' ? 'Article编号' : 'Article number', key: 'article_number', width: 100},
        {
          name: _vm.lang=='zh' ? '商品名称' : 'product name',
          key: 'page_name',
          render: (h, { row }) =>
            h('div', { class: 'item-info' }, [
              h('div', { class: 'item-name' }, row.itemName)
            ])
        },
        { name: _vm.lang=='zh' ? '库存' : 'in stock', key: 'store', width: 150 },
        {
          name: _vm.lang=='zh' ? '价格（¥）':'Price(¥)',
          key: 'price',
          width: 150,
          render: (h, { row }) => h('span', {}, row.price / 100)
        },
        { name: _vm.lang=='zh' ? '状态': 'state', key: 'status'},
        // { name: lang=='zh' ? '来源': 'source', key: 'source'},
        { 
          name: _vm.lang=='zh' ? '上架时间': 'Added time', 
          key: 'online_date',
          render: (h, { row }) => h('span', {}, _vm.timestampToTime(row.online_date))
        },
        { 
          name: _vm.lang=='zh' ? '下架时间': 'Removal time', 
          key: 'offline_date',
          render: (h, { row }) => h('span', {}, _vm.timestampToTime(row.offline_date))
        },
        { name: _vm.lang=='zh' ? '商品是否同步':'Product synchronization', key: 'product_sync'},
      ]
    },"hooks":{
      beforeSearch: _vm.beforeSearch,
      afterSearch: _vm.afterSearch
    }},on:{"select":_vm.onSelect,"selection-change":_vm.onSelectionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }